import classNames from 'classnames'
import { ticketAlmostExpiredMinutes } from '../../../config/const'
import { useCountdown } from '../../../hooks/dayjs/useCountdown'

export default function CountdownTime({ timestamp }) {
  const { hours, minutes, seconds, isExpired } = useCountdown(timestamp)

  const isAlmostExpired =
    !isExpired && Number(hours) === 0 && Number(minutes) <= ticketAlmostExpiredMinutes

  return (
    <span className={classNames('info_value', { redValue: isAlmostExpired })}>
      {`${hours} год. ${minutes} хв. ${seconds} сек.`}
    </span>
  )
}
